import parse from "html-react-parser"
import "../../style/list.css"
import { speakOutLoudRichtext, stopSpeechToText } from "../../services/functions"
import { useAccessibility } from "../../context/AccessibilityContext"

type BaseRichtextType = {
    content: any
    classProps?: string
    customColor?: string
    linksNotInPrimary?: boolean
}

export default function BaseRichtext(props: BaseRichtextType) {
    console.log(props.content)
    const { readText } = useAccessibility()
    const options = {
        replace: (domNode: any) => {
            if (domNode.name === "strong") {
                return <strong className="text-primary">{domNode.children[0].data}</strong>
            }
            if (domNode.name === "code") {
                return <></>
            }
            if (domNode.name === "a") {
                return (
                    <a 
                        href={domNode.attribs?.href} 
                        target={domNode.attribs?.target} 
                        title={domNode.attribs?.title}
                        className={`${props.linksNotInPrimary ? "" : "text-primary hover:text-primary/80 underline"}`}
                    >
                        {domNode.attribs?.title || domNode.children[0].data}
                    </a>
                )
            }
            return undefined
        },
    }

    return (
        <p
            onMouseLeave={readText ? () => stopSpeechToText() : () => {}}
            onMouseEnter={readText ? () => speakOutLoudRichtext(parse(props.content ?? "Hallo", options)) : () => {}}
            className={`text-sm ${props.classProps} ${props.customColor} `}>
            {parse(props.content ?? "", options)}
        </p>
    )
}
